<div class="breadcrumb-shipment-nav flex items-center gap-0 shrink-0">
  <div class="breadcrumb-shipment-nav__input-wrap">
    <span class="breadcrumb-shipment-nav__prefix">#</span>
    <input
      type="text"
      class="breadcrumb-shipment-nav__input"
      [(ngModel)]="shipmentInput"
      [ngModelOptions]="{ standalone: true }"
      (keydown)="onInputKeydown($event)"
      (blur)="onSubmit()"
      [attr.size]="shipmentInput.length || 1"
      [attr.aria-label]="'shipmentNo' | translate"
    />
  </div>

  <app-entity-navigator
    appearance="compact"
    [canPrev]="navigationState().canPrev"
    [canNext]="navigationState().canNext"
    [prevTooltip]="'previous' | translate"
    [nextTooltip]="'next' | translate"
    (prev)="onPrev()"
    (next)="onNext()"
  ></app-entity-navigator>
</div>
